<script lang="ts">
    import { _ } from 'svelte-i18n';

    import SelectHour from '../../../shared/SelectHour.svelte';
    import type { Assignment } from '../Assignment';
    import Opacity from '../../../shared/Opacity.svelte';
    import { debug } from '../../../../stores/store';
    import { AssignmentApi } from '../AssignmentApi';
    import { get } from 'svelte/store';
    import { api } from '../../../../stores/api';
    import { RouteSummaryApp } from './RouteSummaryApp/RouteSummaryApp';
    import { rsa } from './RouteSummaryApp/rsa';

    export let assignment: Assignment;
    export let updateServer: boolean = true;
    export let disabled: boolean = false;
    export let onChange: (selectedHour: string) => boolean = () => true;

    let hour: string = assignment.getStartHourRoute();

    function updateStartTimeRoute(selectedHourHHMM: string) {
        let fullDateString = assignment.getStartDateRoute();
        console.log('updateStartTimeRoute', fullDateString, selectedHourHHMM);
        let [date, time] = fullDateString.split(' ');
        let newDateString = date + ' ' + selectedHourHHMM + ':00';
        assignment.setStartDateRoute(newDateString);
        //assignment.removeRouteInfo();
        if (updateServer) {
            let routeInfo = assignment.getRouteInfo();
            if (routeInfo && routeInfo.reorder_stack && routeInfo.reorder_stack.length) {
                $rsa.executeAction(RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_RECALCULATE);
                onChange(selectedHourHHMM);
            } else {
                AssignmentApi.setStartDateRoute(
                    get(api),
                    assignment.getId(),
                    assignment.getStartDateRoute()
                )
                    .then(response => {
                        assignment.setStartDateRoute(response.start_time_route);
                        assignment.setRouteInfo(response.route_info);
                        assignment = assignment;
                    })
                    .finally(() => {
                        onChange(selectedHourHHMM);
                    });
            }
        } else {
            assignment = assignment;
            onChange(selectedHourHHMM);
        }
    }

    $: {
        hour = assignment.getStartHourRoute();
    }
</script>

<div style="display: flex; align-items: center; column-gap: 10px;">
    <div style="font-size: var(--font-size-tactical-plan);">{$_('start_time')}:</div>
    <SelectHour
        {disabled}
        {hour}
        styleMode="underline"
        withBorder={true}
        onChange={selectedHour => {
            updateStartTimeRoute(selectedHour);
            return true;
        }}
    />
</div>
